import { isMobile } from "react-device-detect";
import Banner from "../components/BannerNew";
import Copyrights from "../components/Copyrights";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Styles from "../components/Styles";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";

export const PrivacyPage = () => {
  const translationContext = useTranslation();
  return (
    <div>
      <Styles />
      <Header
        translation={translationContext.t}
        translationContext={translationContext}
      />
      <Banner showSearchBar={false} minHeight={isMobile ? "120px" : "300px"} />
      <PrivacyContent />
      <Footer />
      <Copyrights />
    </div>
  );
};

const PrivacyContent = () => {
  const translationContext = useTranslation();
  const [currentLang, setCurrentLang] = useState(
    translationContext?.i18n?.language
  );
  
  const primaryColor = "#003663";

  const containerStyle = {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "30px 20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 15px rgba(0, 0, 0, 0.1)",
  };

  const headerStyle = {
    color: primaryColor,
    marginBottom: "20px",
    paddingBottom: "15px",
    borderBottom: "1px solid #eee",
    fontSize: isMobile ? "24px" : "32px",
    fontWeight: "700",
  };

  const subHeadingStyle = {
    color: primaryColor, 
    marginTop: "30px",
    marginBottom: "15px",
    fontSize: isMobile ? "18px" : "22px",
    fontWeight: "600",
  };

  const lastUpdatedStyle = {
    color: "#666",
    fontStyle: "italic",
    marginBottom: "30px",
    display: "block",
  };

  const paragraphStyle = {
    color: primaryColor,
    fontSize: isMobile ? "14px" : "16px",
    lineHeight: "1.6",
    marginBottom: "20px",
  };

  const listItemStyle = {
    color: primaryColor,
    marginBottom: "10px",
    paddingLeft: "15px",
    position: "relative",
    lineHeight: "1.6",
  };

  const bulletPointStyle = {
    display: "inline-block",
    width: "6px",
    height: "6px",
    backgroundColor: primaryColor,
    borderRadius: "50%",
    marginRight: "10px", 
    verticalAlign: "middle",
  };

  const contactInfoStyle = {
    marginTop: "30px",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
    color: primaryColor,
  };

  let textAl = (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Politika e Privatësisë</h1>
      <span style={lastUpdatedStyle}>Përditësuar së fundmi më: 02 Shtator, 2023</span>
      
      <p style={paragraphStyle}>
        Politika e Privatësisë së FluturoLire L.L.C., e njohur si FluturoLire, ofron këtë politikë të privatësisë me bindjen se të gjithë përdoruesit e këtij faqjeje interneti dhe klientët duhet të kuptojnë se si mbledhim, përdorim, ruajmë, transferojmë dhe zbulojmë informacion personal përmes faqes sonë interneti në www.fluturolire.com (Faqja interneti), shërbimeve të ndryshme të ofruara nga FluturoLire dhe furnizuesve tanë të shërbimeve të tretë dhe mundësitë që keni në lidhje me atë informacion.
      </p>

      <h2 style={subHeadingStyle}>Të dhënat që mbledhim</h2>
      <p style={paragraphStyle}>
        Përdoruesit tanë (edhe "ju" ose "juaj") mund të kenë qasje në disa veçori dhe shërbime nëpërmjet Faqes interneti, duke përfshirë krijimin e një llogarie, identifikimin, përdorimin e mjetit tonë të rezervimit online, fitimin e shpërblimeve, aplikimin për një punë, planifikimin e një demonstrimi, dërgimin e nje email-i, shkarkimin e një raporti, planifikimin e një analize të udhëtimit falas, kontaktimin tonë për informacion, abonimin për përditësimet me email dhe referimin e nje miqti (bashkësisht, Shërbimet).
      </p>
      
      <h2 style={subHeadingStyle}>Përdorimi i të dhënave tuaja</h2>
      <p style={paragraphStyle}>
        Kur përdorni Shërbimet, ju jeni duke pajtuar me mbledhjen, ruajtjen, transferimin, procesimin dhe përdorimin e të dhënave tuaja personale për qëllimet e përshkruara në këtë politikë. Në disa raste, përdorimi i informacionit të mbledhur përmes Faqes interneti do të kufizohet në qëllimin e ofrimit të shërbimit për të cilin klienti i grupit të përdoruesve të mbyllur ("Klient(i)") ka angazhuar FluturoLire.
      </p>

      <h2 style={subHeadingStyle}>Informacioni personal që mbledhim</h2>
      <div style={paragraphStyle}>
        Nëse zgjidhni të përdorni ose të hyni në ndonjë prej Shërbimeve, duhet të siguroheni informacion personal për ta bërë këtë, duke përfshirë:
        <div style={{ marginTop: "10px" }}>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Emrin tuaj</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Adresën postare</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Adresën email</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Numrin e telefonit</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Numrin e njohësit të udhetarit</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Numrin e pasaportës</div>
        </div>
      </div>

      <h2 style={subHeadingStyle}>Cookies dhe teknologjitë e ngjashme</h2>
      <p style={paragraphStyle}>
        Cookies janë paketa të vogla të informacionit që ruhen në pajisjen tuaj dhe aktivizohen kur vizitoni faqen tonë interneti. Ne përdorim cookies për të ndjekur aktivitetin e përdoruesve dhe për të ruajtur informacionin tuaj të preferencave. Cookies janë të rëndësishme për funksionimin e faqes sonë interneti dhe mund t'ju ndihmojnë të navigoni më lehtë dhe të merrni përvojë më të mirë në internet.
      </p>

      <h2 style={subHeadingStyle}>Ndryshimet në Politikën e Privatësisë</h2>
      <p style={paragraphStyle}>
        Nëse vendosim të ndryshojmë mënyrën se si mbledhim ose përdorim informacion, do të përditësojmë këtë Politikë të Privatësisë për të reflektuar ndryshimet dhe do t'ju njoftojmë duke përditësuar datën e 'modifikuar së fundmi' dhe duke postuar një njoftim në Shërbime. Nëse përdorni ose hyni në ndonjë prej Shërbimeve pasi kjo politikë është ndryshuar, jeni të lidhur nga ndryshimet në këtë Politikë të Privatësisë.
      </p>

      <div style={contactInfoStyle}>
        <h2 style={{ ...subHeadingStyle, marginTop: 0 }}>Na kontaktoni</h2>
        <p style={paragraphStyle}>
          Nëse keni pyetje në lidhje me këtë Politikë të Privatësisë ose ndonjë aspekt të përdorimit të të dhënave tuaja personale nga ne, ju lutemi na kontaktoni:
        </p>
        <p style={{ ...paragraphStyle, fontWeight: "600" }}>
          FluturoLire L.L.C<br />
          Bedri Berisha Nr.53 H4 Kati 0 P2<br />
          info@fluturolire.com
        </p>
      </div>
    </div>
  );

/*  replace the old textEn block with this  */
/* ----------  textEn (FULL)  ---------- */
/* ----------  textEn (FULL, UNCHANGED CONTENT)  ---------- */
let textEn = (
  <div style={containerStyle}>
    <h1 style={headerStyle}>Privacy&nbsp;Policy</h1>
    <span style={lastUpdatedStyle}>Last modified on: September&nbsp;2,&nbsp;2023</span>

    <p style={paragraphStyle}>
      Privacy Policy of FluturoLire&nbsp;L.L.C., known as FluturoLire, provides this privacy policy with the belief that all users of this website and clients should understand how we collect, use, store, transfer, and disclose personal information through our website at&nbsp;<a href="https://www.fluturolire.com">www.fluturolire.com</a> (the "Website"), the various services offered by FluturoLire, and our third-party service providers, as well as the choices you have regarding that information.
    </p>

    <p style={paragraphStyle}>
      Our users (also referred to as "you" or "your") may access various features and services through the Website, including creating an account, identifying yourself, using our online booking tool, earning rewards, applying for a job, scheduling a demo, sending an email, downloading a report, planning a free travel analysis, contacting us for information, subscribing to email updates, and referring a friend (collectively, "Services"). Your personal information will include any information available to us and may be used for reasonable purposes to identify you ("Personal Information"). Personal Information will be collected, received, and used by the Services in the manner described in this Privacy Policy. The legal definition of Personal Information depends on your physical location and may include other types of information. Only the definition applicable in your physical location will apply under this Privacy Policy.
    </p>

    <p style={paragraphStyle}>
      By using the Services, you agree to the collection, storage, transfer, processing, and use of your personal data for the purposes described in this policy. In some cases, the use of information collected through the Website will be limited to the purpose of providing the service for which a closed group client ("Client") has engaged FluturoLire; in this case, a separate agreement (Client Agreement) may govern the provision, access, and use of the Website, including the processing of Personal Information and data submitted through Clients. A Client who has signed a Client Agreement with FluturoLire may authorize us to collect, process, and store Personal Information and Client-related data associated with you. If you have questions regarding specific configurations of the Website or what information FluturoLire is authorized by the Client to process on your behalf, you may contact the applicable Client administrator or FluturoLire using the contact information provided in this Privacy Policy.
    </p>

    <h2 style={subHeadingStyle}>What happens when this Privacy Policy changes?</h2>
    <p style={paragraphStyle}>
      If we decide to change how we collect or use information, we will update this Privacy Policy to reflect the changes and notify you by updating the 'last modified' date below and posting a notice in the Services. If you use or access any of the Services after this policy has been changed, you are bound by the changes to this Privacy Policy. If you do not agree with any changed version of this Privacy Policy, you should not use or access our Services.
    </p>

    <p style={paragraphStyle}><em>This Privacy Policy was last modified on: September&nbsp;2,&nbsp;2023.</em></p>

    <h2 style={subHeadingStyle}>Personal Information We Collect About You and How We Use&nbsp;It</h2>

    <h3 style={subHeadingStyle}>Information You Provide to&nbsp;Us</h3>
    <p style={paragraphStyle}>
      If you choose to use or access any of the Services, you must provide personal information to do so, including your name, postal address, email address, phone number, traveler ID number, passport number, other contact information, and travel itinerary data. This information is used to: (i) provide identification information on the Website and to perform processing functions and Services that FluturoLire has engaged; (ii) provide contact information for assistance with passports, itinerary changes, ticket honors, accounts, travel reports, and any other Client issue or request; (iii) inform you of any changes or important information related to your reservation; (iv) sign up for a rewards program; and (v) for other purposes outlined below in this Privacy Policy. The Client must ensure the confidentiality of Client data and Personal Information and is aware of the data security risks.
    </p>

    <p style={paragraphStyle}>
      While Personal Information may be linked to a Client who has signed a Client Agreement with FluturoLire, we cannot control or use Personal Information on behalf of the Client for other Client purposes. If you are a Client and wish to request access to, modify, stop using, deactivate, correct, delete, or make a complaint about Personal Information that the Client has authorized FluturoLire to collect, use, process, or store for Client purposes, you must contact your applicable Client.
    </p>

    <h3 style={subHeadingStyle}>Information Automatically Provided to&nbsp;Us</h3>
    <p style={paragraphStyle}>
      When you use the Services, we may automatically collect technical data about your device, website activity, and how you use the Services. This information may include your device's IP address, browser type, browser version, the page you visited before and after our website, your time spent on our website, the pages you view on our website, your device identifier, and how you interact with the Services. We may collect this information through technologies such as cookies, web beacons, and similar tools. This information is used to: (i) enable the functioning of the Services; (ii) monitor and analyze the use and performance of the Services; (iii) improve our website and provide you with a better experience; and (iv) for other purposes outlined in this Privacy Policy. We do not retain this information for more than one year and will not use this information for other purposes included in this Privacy Policy.
    </p>

    <h3 style={subHeadingStyle}>Cookies</h3>
    <p style={paragraphStyle}>
      Cookies are small packets of information stored on your device and activated when you visit our website. We use cookies to track user activity and to store your preference information. Cookies are essential for the operation of our website and can help you navigate more easily and have a better online experience. For more information on cookies and how to manage your cookie preferences, please read the Cookie Policy on this Website.
    </p>

    <h3 style={subHeadingStyle}>Web Beacons</h3>
    <p style={paragraphStyle}>
      Web beacons are small images placed on our website or in our emails. We use web beacons to track user behavior and analyze the effectiveness of our communications and marketing strategies. For more information on web beacons and how they work, you can read more in the Cookie Policy on this Website.
    </p>

    <h3 style={subHeadingStyle}>Information We Collect from Other&nbsp;Sources</h3>
    <p style={paragraphStyle}>
      We may obtain information about you from other sources, such as public data or provided by third-party service providers and business partners. We may use this information to supplement and use the Services and for the purposes specified in this Privacy Policy.
    </p>

    <h2 style={subHeadingStyle}>Use of Your Personal&nbsp;Data</h2>
    <ul style={{ paddingLeft: 0, listStyle: "none" }}>
      <li style={listItemStyle}><span style={bulletPointStyle}></span>To operate, manage, and improve the Services you use.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span>To confirm your identity and ensure you have access to the Services you have selected.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span>To communicate with you regarding the Services, including potential changes to Services, ticket changes, itinerary honors, and other important information.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span>To customize your user experience on our website and personalize the content you see.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span>To analyze and monitor the use of the Services and improve their content and functionality.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span>To send you informative or promotional messages, including notifications about special offers, activities, surveys, and opinion polls.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span>To allow business partners and third-party service providers to perform services on our behalf, including product and service development, data analysis, marketing, and message delivery.</li>
    </ul>

    <h2 style={subHeadingStyle}>Use of Your Personal Data for Marketing&nbsp;Purposes</h2>
    <p style={paragraphStyle}>
      We may use your personal data for marketing purposes, including sending offers, notifications about our products and services, and promoting our business partners and third parties. You have the right to opt-out of receiving these notifications at any time by following the instructions in the messages or by contacting us directly. You can also change your notification preferences in your user account.
    </p>

    <h2 style={subHeadingStyle}>Provision of Your Personal&nbsp;Data</h2>
    <p style={paragraphStyle}>
      Providing your personal data is optional, but it is necessary for the use of some Services. In certain cases, if you do not provide the requested data, you may not be able to use some or all of the Services. This information may be required when:
    </p>
    <div style={{ marginTop: 10 }}>
      <div style={listItemStyle}><span style={bulletPointStyle}></span>Registering for an account or creating a user profile.</div>
      <div style={listItemStyle}><span style={bulletPointStyle}></span>Using or requesting to use some of our Services.</div>
      <div style={listItemStyle}><span style={bulletPointStyle}></span>Seeking assistance or other support.</div>
      <div style={listItemStyle}><span style={bulletPointStyle}></span>Registering for a rewards program or similar promotion.</div>
      <div style={listItemStyle}><span style={bulletPointStyle}></span>Contractual agreements and Client Agreements and other similar agreements.</div>
      <div style={listItemStyle}><span style={bulletPointStyle}></span>Participating in surveys, polls, contests, or other similar promotions.</div>
      <div style={listItemStyle}><span style={bulletPointStyle}></span>Subscribing to a ticket.</div>
    </div>

    <h2 style={subHeadingStyle}>Sharing of Your Personal&nbsp;Data</h2>
    <ul style={{ paddingLeft: 0, listStyle: "none" }}>
      <li style={listItemStyle}><span style={bulletPointStyle}></span><strong>Business Partners:</strong> We may share your data with our business partners for specified purposes, including providing products and services you have requested, data analysis, and marketing. Our business partners will use your data only for authorized purposes and are required to protect the confidentiality of your data.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span><strong>Third-Party Service Providers:</strong> We may use third-party service providers to provide, develop, improve, analyze, and distribute the Services and to assist with the operation of our website. These third parties may have access to your personal data only as necessary to perform the services they provide and are required to protect the confidentiality of your data.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span><strong>Authorities and Law Enforcement:</strong> We may share your personal data with authorities and law enforcement when necessary to comply with the law, protect our rights or the rights of others, and for other legal purposes.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span><strong>Other FluturoLire Clients:</strong> We may share your personal data with other FluturoLire clients for user purposes, including another passenger, if you are linked to their booking or have requested such sharing.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span><strong>Third-Party Organizations:</strong> We may share your personal data with third-party organizations if you participate in rewards programs offered by these organizations, such as a rewards program.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span><strong>General Public:</strong> We may share aggregate and non-identifiable information with the general public and third parties for analytical, research, marketing, and other purposes included in this Privacy Policy.</li>
      <li style={listItemStyle}><span style={bulletPointStyle}></span><strong>Others with Devices:</strong> If you use the Services together with others on other devices, they may have access to your personal data in your user account.</li>
    </ul>

    <h2 style={subHeadingStyle}>Modification and Deletion of Your Personal&nbsp;Data</h2>
    <p style={paragraphStyle}>
      You have the right to request access to, correction, deletion, or restriction of the use of your personal data, and to object to the processing of your personal data in certain ways. You also have the right to receive your personal data provided by you and transmit it to another organization (e.g., if you want to share it elsewhere). To exercise any of these rights, please contact us using the details below.
    </p>

    <div style={contactInfoStyle}>
      <h2 style={{ ...subHeadingStyle, marginTop: 0 }}>Contact&nbsp;Us</h2>
      <p style={paragraphStyle}>
        If you have questions about this Privacy Policy or any aspect of our use of your personal data, please contact us:
      </p>
      <p style={{ ...paragraphStyle, fontWeight: 600 }}>
        FluturoLire&nbsp;L.L.C.<br />
        Bedri&nbsp;Berisha&nbsp;Nr.&nbsp;53&nbsp;H4&nbsp;Kati&nbsp;0&nbsp;P2<br />
        info@fluturolire.com
      </p>
    </div>
  </div>
);
/* ------------------  end textEn  ------------------ */


  
  let textDe = (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Datenschutzrichtlinie</h1>
      <span style={lastUpdatedStyle}>Zuletzt aktualisiert: 2. September 2023</span>
      
      <p style={paragraphStyle}>
        Datenschutzrichtlinie von FluturoLire L.L.C., bekannt als FluturoLire, bietet diese Datenschutzrichtlinie mit der Überzeugung an, dass alle Benutzer dieser Website und Kunden verstehen sollten, wie wir personenbezogene Daten über unsere Website unter www.fluturolire.com (die "Website"), die verschiedenen von FluturoLire angebotenen Dienste und unsere Drittanbieter sammeln, verwenden, speichern, übertragen und offenlegen, sowie die Wahlmöglichkeiten, die Sie hinsichtlich dieser Informationen haben.
      </p>

      <h2 style={subHeadingStyle}>Daten, die wir sammeln</h2>
      <p style={paragraphStyle}>
        Unsere Benutzer (auch als "Sie" oder "Ihr" bezeichnet) können über die Website auf verschiedene Funktionen und Dienste zugreifen, einschließlich der Erstellung eines Kontos, der Identifizierung, der Nutzung unseres Online-Buchungstools, dem Sammeln von Belohnungen, der Bewerbung auf eine Stelle, der Planung einer Demo, dem Versenden einer E-Mail, dem Herunterladen eines Berichts, der Planung einer kostenlosen Reiseanalyse, der Kontaktaufnahme für Informationen, dem Abonnieren von E-Mail-Updates und der Empfehlung eines Freundes (gemeinsam "Dienste").
      </p>
      
      <h2 style={subHeadingStyle}>Verwendung Ihrer Daten</h2>
      <p style={paragraphStyle}>
        Durch die Nutzung der Dienste stimmen Sie der Erfassung, Speicherung, Übertragung, Verarbeitung und Nutzung Ihrer personenbezogenen Daten für die in dieser Richtlinie beschriebenen Zwecke zu. In einigen Fällen wird die Nutzung der Informationen, die über die Website gesammelt werden, auf den Zweck beschränkt, für den ein geschlossener Gruppen-Kunde ("Kunde") FluturoLire engagiert hat.
      </p>

      <h2 style={subHeadingStyle}>Personenbezogene Daten, die wir sammeln</h2>
      <div style={paragraphStyle}>
        Wenn Sie sich entscheiden, eine der Dienstleistungen zu nutzen oder darauf zuzugreifen, müssen Sie personenbezogene Daten angeben, einschließlich:
        <div style={{ marginTop: "10px" }}>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Ihren Namen</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Postanschrift</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>E-Mail-Adresse</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Telefonnummer</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Reisenden-ID-Nummer</div>
          <div style={listItemStyle}><span style={bulletPointStyle}></span>Reisepassnummer</div>
        </div>
      </div>

      <h2 style={subHeadingStyle}>Cookies und ähnliche Technologien</h2>
      <p style={paragraphStyle}>
        Cookies sind kleine Informationspakete, die auf Ihrem Gerät gespeichert werden und aktiviert werden, wenn Sie unsere Website besuchen. Wir verwenden Cookies, um die Benutzeraktivität zu verfolgen und Ihre Präferenzen zu speichern. Cookies sind für den Betrieb unserer Website unerlässlich und können Ihnen helfen, einfacher zu navigieren und ein besseres Online-Erlebnis zu haben.
      </p>

      <h2 style={subHeadingStyle}>Änderungen der Datenschutzrichtlinie</h2>
      <p style={paragraphStyle}>
        Wenn wir beschließen, wie wir Informationen sammeln oder verwenden, zu ändern, werden wir diese Datenschutzrichtlinie aktualisieren, um die Änderungen widerzuspiegeln, und Sie durch Aktualisieren des "letzten Änderungsdatums" und durch Bekanntgabe in den Diensten benachrichtigen. Wenn Sie die Dienste nach der Änderung dieser Richtlinie nutzen oder darauf zugreifen, sind Sie an die Änderungen dieser Datenschutzrichtlinie gebunden.
      </p>

      <div style={contactInfoStyle}>
        <h2 style={{ ...subHeadingStyle, marginTop: 0 }}>Kontaktieren Sie uns</h2>
        <p style={paragraphStyle}>
          Wenn Sie Fragen zu dieser Datenschutzrichtlinie oder zu einem Aspekt unserer Verwendung Ihrer personenbezogenen Daten haben, kontaktieren Sie uns bitte:
        </p>
        <p style={{ ...paragraphStyle, fontWeight: "600" }}>
          FluturoLire L.L.C<br />
          Bedri Berisha Nr.53 H4 Kati 0 P2<br />
          info@fluturolire.com
        </p>
      </div>
    </div>
  );

  return (
    <Fragment>
      <section className="content" style={{ padding: isMobile ? "20px 0" : "95px 0", backgroundColor: "#f5f7fa" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              {currentLang == 'al' ? textAl : currentLang == 'en' ? textEn : currentLang == 'de' ? textDe : textEn}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default PrivacyPage; 